import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useHistory, Link, useLocation } from 'react-router-dom'
import MoreAction from '../MoreActions/MoreAction';
import PortalPopup from '../PortalPopup/PortalPopup';
import ShowAll from '../ShowAll/ShowAll';
import WhyPopup from '../WhyPopup/WhyPopup';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { dateFormat } from '../../helpers/dateFormat';
import { createApiClient } from '@oneblinktech-org/helios-base';
import SocialIcons from '../SocialIcons';
import GroupBubble from '../GroupBubble';
import { formatPhoneNumber } from '../../helpers/globals';
import GroupStatus from '../GroupStatus';
import { Spin } from 'antd'
import SponsorLinkModal from './SponsorLinkModal';

const ProfileInfo = ({ isEdit }) => {
    const [isMyWhyOpen, setMyWhyOpen] = useState(false);
    const [isShowAllOPen, setShowAllOpen] = useState(false);
    const [isMoreActionOpen, setMoreActionOpen] = useState(false);
    const [isPublicView, setPublicView] = useState(false)
    const [sponsorLinks, setSponsorLinks] = useState([])
    const [showToast, setShowToast] = useState(false)
    const [user, setUser] = useState(null)
    const [loading, setLoading] = useState(false)
    const [userGroups, setUserGroups] = useState([])
    const [openLinkModal, setOpenLinkModal] = useState(false)
    const [actionIndex, setActionIndex] = useState(null)

    const relativeLayerRef = useRef()
    const actionLayerRef = useRef(new Map())

    useEffect(() => {
        if (user)
            document.title = `Profile: ${user?.firstname ? user?.firstname : ''} ${user?.lastname ? user?.lastname : ''}`
        else
            document.title = `Profile`
    }, [user])

    const location = useLocation();
    const publicUserId = new URLSearchParams(location.search).get("userId");

    const apiUrl = process.env.REACT_APP_API_URL;
    const { get } = createApiClient({ apiUrl });

    const getMainDomain = (hostname) => {
        const parts = hostname.split('.')
        return parts.slice(-2).join('.')
    }
    const mainDomain = getMainDomain(window.location.hostname)
    const adminDomain = `admin.${mainDomain}`

    const userData = useSelector((state) => state.profile.user)
    const history = useHistory();
    var pattern = /^((http|https|ftp):\/\/)/;
    const token = localStorage.getItem('h-access_token')

    const isLoggedIn = localStorage.getItem('h-access_token')

    useEffect(() => {
        if (publicUserId) {
            getPublicUserData()
        } else
            setUser(userData.data)
    }, [userData.data, publicUserId])

    useEffect(() => {
        if (user) {
            if (publicUserId) {
                setUserGroups(user?.groups?.filter((i) => i.application_status === 2))
            } else {
                setUserGroups(user?.groups)
            }
        }
    }, [user])

    useEffect(() => {
        if (user?.user_setting?.legacy_user_id)
            getSponserLinks()
    }, [user?.user_setting?.legacy_user_id])

    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false)
            }, 5000)
        }
    }, [showToast])

    async function getSponserLinks() {
      try {
        const result = await get(
          `https://${adminDomain}/my2/user-sponsor-links/${user?.user_setting?.legacy_user_id}`)
        if (result)
          setSponsorLinks(result?.sponsorLinks)
      } catch (error) {
        console.log('error', error);
      }
    }

    async function getPublicUserData() {
        try {
            setLoading(true)
            if (token) {
                const result = await get(
                    `ithaca/users/get/${publicUserId}`, token ? {
                        "Authorization": `Bearer ` + token
                    } : {})
                if (result) {
                    setUser(result)
                }
                setLoading(false)
            } else {
                const result = await get(
                    `ithaca/users/public/get/${publicUserId}`)
                if (result) {
                    setUser(result)
                }
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            if (error.response.status === 404)
                history.push("/")
        }
    }

    // const openWhyPopup = useCallback(() => {
    //     setMyWhyOpen(!isMyWhyOpen);
    // }, []);

    const closeWhyPopup = useCallback(() => {
        setMyWhyOpen(false);
    }, []);

    // const openShowAll = useCallback(() => {
    //     setShowAllOpen(true);
    // }, []);

    const closeShowAll = useCallback(() => {
        setShowAllOpen(false);
    }, []);

    const openMoreAction = useCallback(() => {
        setMoreActionOpen(true);
    }, []);

    const closeMoreAction = useCallback(() => {
        setMoreActionOpen(false);
    }, []);

    const onFrameContainerClick = useCallback(() => {
        history.push("/EditProfile")
    }, []);

    const handleEditWhyClick = () => {
        history.push({ pathname: '/EditProfile', state: { scrollTo: 'my_why_description' } });
    };

    const getGridTemplateAreas = () => {
        let col1 = [];
        let col2 = [];

        if (user.email) col1.push("email");
        if (user?.main_phone) col1.push("phone");
        if (user?.user_setting?.mobile_phone) col1.push("cell");
        if (user?.user_setting?.website) col1.push("url");
        if (user?.address || user?.address2 || user?.city || user?.state || user?.zipcode) col1.push("address");

        if (user?.user_setting?.business_description) col2.push("business");
        if (user?.user_setting?.profession) col2.push("profession");
        if (user?.user_setting?.specialty) col2.push("speciality");

        // If col1 is shorter, pull fields from col2 to balance it
        while (col1.length < 5 && col2.length > 0) {
            col1.push(col2.shift());
        }

        // Combine into grid-template-areas
        const maxLength = Math.max(col1.length, col2.length);
        let template = "";
        for (let i = 0; i < maxLength; i++) {
            template += `"${col1[i] || "."} ${col2[i] || "."}"\n`;
        }

        return template;
    };

    // Function to handle setting and cleaning up refs
    const setActionRef = (index, node) => {
        if (node) {
            // Add the node to the map using the index as the key
            actionLayerRef.current.set(index, node);
        } else {
            // Remove the node from the map when the component unmounts
            actionLayerRef.current.delete(index);
        }
    };


    if (user) {
        const hasVisibleAddress =
            (user?.address || user?.address2 || user?.city || user?.state || user?.zipcode) &&
            (
                ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('address') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('address'))) ||
                ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('address2') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('address2'))) ||
                ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('city') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('city'))) ||
                ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('state') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('state'))) ||
                ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('zipcode') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('zipcode')))
            );

        const hasVisibleMyInfo =
            (user?.email && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('email') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('email')))) ||
            (user?.main_phone && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('main_phone') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('main_phone')))) ||
            (user?.user_setting?.mobile_phone && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('mobile_phone') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('mobile_phone')))) ||
            (user?.user_setting?.website && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('website') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('website')))) ||
            hasVisibleAddress ||
            (user?.user_setting?.business_description && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('business_description') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('business_description')))) ||
            (user?.user_setting?.profession && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('profession') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('profession')))) ||
            (user?.user_setting?.specialty && (((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('specialty') || (publicUserId && userData.data.id !== publicUserId)))) && (publicUserId && userData.data.id !== publicUserId)) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('specialty'))));

      return (
            <Spin spinning={(userData.loading || loading)} size='large' wrapperClassName={`${(publicUserId && !isLoggedIn) ? 'w-100' : ''}`}>
                <div className={`profile-info ${(publicUserId && !isLoggedIn) ? 'public-container' : ''}`}>
                    <div className="profile-inner-info">
                        {/* <div className="component-197-info"> */}
                        <div className={`frame-parent-info edit-profilr md-w-full public-header ${publicUserId ? 'public-header-container' : ''}`}>

                            {/* <div className="iconarrowsnormalleft-parent">
                                        <img
                                            className="iconarrowsnormalleft"
                                            alt=""
                                            src={require('../../assets/images/left.svg').default}
                                        />
                                        <div className="back-to-dashboard">Back to Dashboard</div>
                                    </div> */}
                            <b className="profile-overview">{publicUserId ? '' : "Profile"}</b>
                            {!isPublicView && isLoggedIn && (!publicUserId || userData.data.id === publicUserId) && (
                                <div className="button-edit" onClick={onFrameContainerClick}>Edit Profile</div>
                            )}
                            {/* <div className="cta-parent">
                                    <div className="cta">You have unsaved changes</div>
                                    <div className="component-195">
                                        <div className="cta1">Save</div>
                                    </div>
                                    <div className="cancel">
                                        <div className="cancel1">Cancel</div>
                                    </div>
                                </div> */}
                        </div>

                        {userData?.data?.id === publicUserId &&
                            <div className='public-view-header' >
                                <label className='view-info'>{`You are seeing what the Public sees. To change your privacy settings > `}
                                    <span className='btn-edit-profile' onClick={onFrameContainerClick}>Edit Your Profile</span>
                                </label>
                                <Link className="close-icon" to={`/profile`} onClick={() => setPublicView(false)}>
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM6.26695 5.26172L9 7.99477L11.7331 5.26172L12.75 6.27867L10.0169 9.01172L12.75 11.7448L11.7331 12.7617L9 10.0287L6.26695 12.7617L5.25 11.7448L7.98305 9.01172L5.25 6.27867L6.26695 5.26172Z" fill="#C7D3E6" />
                                    </svg>
                                </Link>
                            </div>
                        }

                        <div className="info-content">
                            <div className="frame-group-info md-w-full">
                                {/* <div className="frame-child" /> */}
                                <div className="col" style={{ position: 'relative' }} ref={relativeLayerRef}>
                                    <div className="frame-container align-items-start">
                                        <div className='flex flex-row align-items-center justify-content-between w-auto info-header' >
                                            <div className="component-448-parent">
                                                <img
                                                    className="component-448-icon"
                                                    alt=""
                                                    src={user?.full_profile_image_url ? user?.full_profile_image_url : require('../../assets/images/user-avatar.png')}
                                                />
                                                <div className="frame-div">
                                                    <div className="frame-parent1">
                                                        <div className="frame-wrapper">
                                                            <div className="frame-parent2">
                                                                <div className="frame-parent3">
                                                                    <div className="frame-wrapper">
                                                                        <div className="frame-parent4">
                                                                            <div className="profile-name-wrapper">
                                                                                <b className="profile-name">
                                                                                    {`${user?.firstname || ''} ${user?.lastname || ''}`}
                                                                                </b>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {/*<div className="username">{user?.email}</div>*/}
                                                                </div>
                                                                <div className="text-label">
                                                                    {user?.user_setting?.business_name}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="frame-parent5">
                                                            {user?.verified_member &&
                                                                <div className="icons-parent">
                                                                    <img
                                                                        className="icons"
                                                                        alt=""
                                                                        src={require("../../assets/images/icons.svg").default}
                                                                    />
                                                                    <div className="text">Verified User</div>
                                                                </div>
                                                            }
                                                            {user?.member_since && (
                                                                <div className="member-since-wrapper">
                                                                    <div className="text-label">
                                                                        Member since {dateFormat(user.member_since, 'USER_LOGIN_DATE_FORMAT')}
                                                                    </div>
                                                                </div>
                                                            )
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="frame-parent6">
                                                        <SocialIcons
                                                            linkedin={user?.user_setting?.linkedin}
                                                            facebook={user?.user_setting?.facebook}
                                                            twitter={user?.user_setting?.twitter}
                                                            calendly={user?.user_setting?.calendly}
                                                            publicFields={user?.user_setting?.public_fields}
                                                            parentClassName='vector-icon'
                                                            isLogedInUserView={userData.data.id === publicUserId}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* {sponsorLinks && sponsorLinks?.length > 0 &&
                                            <div className='flex flex-column gap-2' >
                                                <b className='sponser-label'>{`My Sponsor Link${sponsorLinks?.length > 1 ? 's' : ''}`}</b>
                                                <div className='flex flex-column gap-1' >
                                                    {sponsorLinks?.map((link, index) => (
                                                        <div className='sponsor-item' key={index}>
                                                            {link?.name && link?.url && (
                                                                <>
                                                                    <span className='label'>
                                                                        {link?.name}: <span className='value'>{link?.url}</span>
                                                                    </span>
                                                                    <div className='flex flex-column align-items-center gap-1 relative' onClick={() => {
                                                                        navigator.clipboard.writeText(link?.url)
                                                                        setShowToast(true)
                                                                    }}>
                                                                        <span className={`toast-text ${showToast ? 'show' : ''}`}>Copied!</span>
                                                                        <img
                                                                            className='copy-img'
                                                                            src={require('../../assets/images/copy-solid.svg').default}
                                                                            alt="Copy icon"
                                                                        />
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        } */}

                                        {!publicUserId &&
                                            <div className='frame-parent7'>
                                                <div className="frame-parent8" onClick={() => setPublicView(true)}>
                                                    <div className="vector-container">
                                                        <img
                                                            className="vector-icon1"
                                                            alt=""
                                                            src={require("../../assets/images/public-view.svg").default}
                                                        />
                                                    </div>
                                                    <div className="cta-wrapper" onClick={() => history.push(`/profile?userId=${user?.id}`)} >
                                                        <div className="cta1">View As Public</div>
                                                    </div>
                                                </div>
                                                {sponsorLinks?.length > 0 &&
                                                    <div className="frame-parent9" onClick={() => setOpenLinkModal(true)} >
                                                        <div className="profile-name-wrapper">
                                                            <div className="vector-frame">
                                                                <img
                                                                    className="vector-icon1"
                                                                    alt=""
                                                                    src={require("../../assets/images/share.svg").default}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="cta-wrapper">
                                                            <div className="cta1">Show Sponsor Links</div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {/* {isPublicView ? null : localStorage.getItem('h-access_token') && (
                                            <div className="frame-parent7">
                                                <div className="frame-parent9">
                                                    <div className="profile-name-wrapper">
                                                        <div className="vector-frame">
                                                            <img
                                                                className="vector-icon1"
                                                                alt=""
                                                                src={require("../../assets/images/share.svg").default}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="cta-wrapper">
                                                        <div className="cta1">Share Link</div>
                                                    </div>
                                                </div>
                                                <div className="frame-parent10">
                                                    <div className="vector-wrapper1">
                                                        <img
                                                            className="icon-color1"
                                                            alt=""
                                                            src={require("../../assets/images/impersonate.svg").default}
                                                        />
                                                    </div>
                                                    <div className="cta-wrapper">
                                                        <div className="cta1">Impersonate</div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                        } */}
                                    </div>

                                    <div className="my-why md-flex-wrap md-w-full">
                                      {((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('my_why_description') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('my_why_description'))) &&
                                            <div className="text-parent relative md-w-full">
                                                <b className="profile-name">My Why: {`${user?.user_setting?.my_why ?? ''}`}</b>
                                                {user?.user_setting?.my_why_description ?
                                                    <div className="text-label">
                                                        {`${user?.user_setting?.my_why_description}`}
                                                    </div>
                                                    :
                                                    <div className="sed-ut-perspiciatis fst-italic" onClick={handleEditWhyClick} >
                                                        {localStorage.getItem('h-access_token') ? 'Add my "Why" description!' : 'This member has not added their “Why” yet'}
                                                    </div>
                                                }
                                            </div>
                                        }
                                        {hasVisibleMyInfo &&
                                            <div className="my-info md-w-full">
                                                <div className="text-wrapper md-w-full">
                                                    <b className="profile-name">My Info</b>
                                                </div>
                                                <div key={isEdit} className="frame-parent13 md-flex-wrap md-w-full" style={{ gridTemplateAreas: getGridTemplateAreas() }}>
                                                    {user?.email && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('email') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('email'))) &&
                                                        <div className="frame-parent15 email">
                                                            <div className="frame-wrapper">
                                                                <b className="label-heading">Email</b>
                                                            </div>
                                                            <div className="placeholder-parent">
                                                                <div className="text-label">
                                                                    {user?.email}
                                                                </div>
                                                                <div className="frame-inner" />
                                                            </div>
                                                        </div>
                                                    }
                                                    {user?.main_phone && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('main_phone') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('main_phone'))) &&
                                                        <div className="frame-parent15 phone">
                                                            <div className="frame-wrapper">
                                                                <b className="label-heading">phone</b>
                                                            </div>
                                                            <div className="placeholder-parent">
                                                                <div className="text-label">{formatPhoneNumber(user?.main_phone)}</div>
                                                                <div className="frame-inner" />
                                                            </div>
                                                        </div>
                                                    }
                                                    {user?.user_setting?.mobile_phone && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('mobile_phone') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('mobile_phone'))) &&
                                                        <div className="frame-parent15 cell">
                                                            <div className="frame-wrapper">
                                                                <b className="label-heading">cell</b>
                                                            </div>
                                                            <div className="placeholder-parent">
                                                                <div className="text-label">{formatPhoneNumber(user?.user_setting?.mobile_phone)}</div>
                                                                <div className="frame-inner" />
                                                            </div>
                                                        </div>
                                                    }
                                                    {user?.user_setting?.website && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('website') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('website'))) &&
                                                        <div className="frame-parent15 url">
                                                            <div className="frame-wrapper">
                                                                <b className="label-heading">url</b>
                                                            </div>
                                                            <div className="placeholder-parent">
                                                                <a
                                                                    className="text-label"
                                                                    href={user?.user_setting?.website}
                                                                    target="_blank" rel="noreferrer"
                                                                >
                                                                    {user?.user_setting?.website}
                                                                </a>
                                                                <div className="frame-inner" />
                                                            </div>
                                                        </div>
                                                    }
                                                    {(user?.address || user?.address2 || user?.city || user?.state || user?.zipcode) &&
                                                        (((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('address') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('address')))
                                                            || ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('address2') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('address2')))
                                                            || ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('city') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('city')))
                                                            || ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('state') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('state')))
                                                            || ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('zipcode') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('zipcode')))) &&
                                                        <div className="frame-parent15 address">
                                                            <div className="frame-wrapper">
                                                                <b className="label-heading">Address</b>
                                                            </div>
                                                            <div className="placeholder-parent">
                                                                <div className="text-label">
                                                                    {`${((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('address') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('address'))) ? user?.address : ''}`}
                                                                    {(user?.address2 && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('address2') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('address2')))) && <div>{user?.address2}</div>}
                                                                    <div>{`${user?.city && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('city') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('city'))) ? user?.city : ''}${user?.city ? ',' : ''} 
                                                                ${user?.state && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('state') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('state'))) ? user?.state : ''} ${user?.zipcode && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('state') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('zipcode'))) ? user?.zipcode : ''}`}</div>
                                                                </div>
                                                                <div className="frame-inner" />
                                                            </div>
                                                        </div>
                                                    }

                                                    {user?.user_setting?.business_description && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('business_description') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('business_description'))) &&
                                                        <div className="frame-parent15 business">
                                                            <div className="frame-wrapper">
                                                                <b className="label-heading">Business DESCRIPTION</b>
                                                            </div>
                                                            <div className="placeholder-parent">
                                                                <div className="text-label">
                                                                    {user?.user_setting?.business_description}
                                                                </div>
                                                                <div className="frame-inner" />
                                                            </div>
                                                        </div>
                                                    }
                                                    {user?.user_setting?.profession && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('profession') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('profession'))) &&
                                                        <div className="frame-parent15 profession">
                                                            <div className="frame-wrapper">
                                                                <b className="label-heading">profession</b>
                                                            </div>
                                                            <div className="placeholder-parent4">
                                                                <div className="text-label">{user?.user_setting?.profession}</div>
                                                                <div className="frame-inner" />
                                                            </div>
                                                        </div>
                                                    }
                                                    {user?.user_setting?.specialty && ((isLoggedIn && (publicUserId === null || (user?.user_setting?.public_fields?.includes('specialty') || (publicUserId && userData.data.id !== publicUserId)))) || (!isLoggedIn && user?.user_setting?.public_fields?.includes('specialty'))) &&
                                                        <div className="frame-parent15 speciality">
                                                            <div className="frame-wrapper">
                                                                <b className="label-heading">Speciality</b>
                                                            </div>
                                                            <div className="placeholder-parent4">
                                                                <div className="text-label">{user?.user_setting?.specialty}</div>
                                                                <div className="frame-inner" />
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </div>

                                    <div className="my-group md-w-full">
                                        <div className="text-group md-w-full">
                                            <b className="profile-name">My Groups</b>
                                            {/*<div className="show-all" >
                                                <div onClick={() => setShowAllOpen(!isShowAllOPen)} >Show All</div>
                                                {isShowAllOPen && (
                                                    // <PortalPopup
                                                    //     overlayColor="rgba(113, 113, 113, 0.3)"
                                                    //     placement="Centered"
                                                    //     onOutsideClick={closeShowAll}
                                                    // >
                                                    <ShowAll onClose={closeShowAll} />
                                                    // </PortalPopup>
                                                )}

                                            </div>*/}
                                        </div>
                                        <div className="show-only-on-mobile my-group-mobile">
                                            {userGroups?.map((item, index) => (
                                                <div class="row" key={index}>
                                                    <Link className="frame-wrapper" to={`/group/` + item.id}>
                                                        <strong>{item.name}</strong>
                                                    </Link>
                                                    <div>
                                                        Member since
                                                        {item.member_since_date && !item.cancelled_at && `Since ${dateFormat(item.member_since_date, 'USER_LOGIN_DATE_FORMAT')}`}
                                                        {item.member_since_date && item.cancelled_at && `${dateFormat(item.member_since_date, 'USER_LOGIN_DATE_FORMAT')} - ${dateFormat(item.cancelled_at, 'USER_LOGIN_DATE_FORMAT')}`}
                                                    </div>
                                                    <div className='d-flex flex-row mt-1 gap-2 justify-content-between'>
                                                        {!publicUserId &&
                                                            <GroupStatus status={item.application_status} />
                                                        }
                                                        <GroupBubble
                                                            member_count={item?.member_count}
                                                            image={item?.group_image_bubbles_url}
                                                            className='group-icon'
                                                        />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="frame-parent25 w-full">
                                            <div className="table-header-cell-parent md-w-full table-header-cells w-full">
                                                <div className="table-header-cell">
                                                    <div className="table-header">
                                                        <b className="label-heading">GROUP NAME</b>
                                                        {/*<img
                                                            className="arrow-down-icon"
                                                            alt=""
                                                            src={require("../../assets/images/arrowdown.svg").default}
                                                        />*/}
                                                    </div>
                                                </div>
                                                {!publicUserId &&
                                                    <div className="table-header-cell table-header-cell1 justify-content-center">
                                                        <div className="cta-wrapper">
                                                            <b className="label-heading">STATUS</b>
                                                        </div>
                                                    </div>
                                                }
                                                <div className="table-header-cell table-header-cell2 justify-content-end">
                                                    <div className="cta-wrapper">
                                                        <b className="label-heading">MY MEMBERSHIP</b>
                                                    </div>
                                                </div>
                                                <div className="table-header-cell justify-content-center">
                                                    <div className="cta-wrapper">
                                                        <b className="label-heading">MEMBERS</b>
                                                    </div>
                                                </div>
                                                {!publicUserId &&
                                                    <div className="table-header-cell justify-content-center">
                                                    </div>
                                                }
                                            </div>
                                            {userGroups?.map((item, index) => {
                                                return (
                                                    <div className="profile-name-wrapper md-w-full table-cells" key={index} >
                                                        <div className="table-cell">
                                                            {/* <img
                                                                className="table-cell-child"
                                                                alt=""
                                                                src={item?.full_profile_image_url ? item?.full_profile_image_url : require("../../assets/images/user-avatar.png").default}
                                                            /> */}
                                                            <Link className="frame-wrapper" to={`/group/` + item.id}>
                                                                <div className="text8">{item.name}</div>
                                                            </Link>
                                                        </div>
                                                        {!publicUserId &&
                                                            <div className="table-cell table-cell1 justify-content-center">
                                                                <GroupStatus status={item.application_status} />
                                                            </div>
                                                        }
                                                        <div className="table-cell table-cell2 justify-content-end">
                                                            <div className="frame-wrapper">
                                                                <div className="text10">
                                                                    <p className="pending mb-0">
                                                                        {item.application_approved_at && !item.cancelled_at && 'Since '}
                                                                        {item.application_approved_at && dateFormat(item.application_approved_at, 'USER_LOGIN_DATE_FORMAT')}
                                                                        {item.application_approved_at && item.cancelled_at && ' - '}
                                                                        {item.cancelled_at && dateFormat(item.cancelled_at, 'USER_LOGIN_DATE_FORMAT')}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className='table-cell justify-content-center'>
                                                            <GroupBubble
                                                                member_count={item?.member_count}
                                                                image={item?.group_image_bubbles_url}
                                                                className='group-icon'
                                                            />
                                                        </div>

                                                        {!publicUserId &&
                                                            <div className="table-cell table-cell4" style={{ position: 'relative' }} id={index} key={index}  >
                                                                {isPublicView ? null : localStorage.getItem('h-access_token') && (
                                                                    <div className="dropdown"
                                                                        ref={(node) => setActionRef(index, node)}
                                                                        onClick={() => {
                                                                            setActionIndex(index)
                                                                            setMoreActionOpen(!isMoreActionOpen)
                                                                        }}>
                                                                        <img
                                                                            className="more-vertical-icon"
                                                                            alt=""
                                                                            src={require("../../assets/images/more-vertical.svg").default}
                                                                        />

                                                                        {isMoreActionOpen && index === actionIndex && (
                                                                            <PortalPopup
                                                                                overlayColor=''
                                                                                placement="Top right"
                                                                                onOutsideClick={closeMoreAction}
                                                                                relativeLayerRef={{ current: actionLayerRef?.current.get(index) }}
                                                                                zIndex={9999}
                                                                                right={20}
                                                                            >
                                                                                <MoreAction
                                                                                    onClose={closeMoreAction}
                                                                                    sponsor_Link={sponsorLinks?.find((i) => i.name === item.name)?.url}
                                                                                />
                                                                            </PortalPopup>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        }
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    </div>

                                    {openLinkModal &&
                                        <PortalPopup
                                            overlayColor={`var(--color-gray-300)`}
                                            placement="Top right"
                                            onOutsideClick={() => setOpenLinkModal(false)}
                                            zIndex={9999}
                                            relativeLayerRef={relativeLayerRef}
                                        >
                                            <SponsorLinkModal sponsorLinks={sponsorLinks} onClose={() => setOpenLinkModal(false)} />
                                        </PortalPopup>
                                    }
                                </div>
                            </div>
                        </div>

                        {/* </div> */}
                    </div>
                </div>
                {/* {isMoreActionOpen && (
                    <PortalPopup
                        overlayColor="rgba(113, 113, 113, 0.3)"
                        placement="Centered"
                        onOutsideClick={closeMoreAction}
                    >
                        <MoreAction onClose={closeMoreAction} />
                    </PortalPopup>
                )} */}

                {/* {isShowAllOPen && (
                    <PortalPopup
                        overlayColor="rgba(113, 113, 113, 0.3)"
                        placement="Centered"
                        onOutsideClick={closeShowAll}
                    >
                        <ShowAll onClose={closeShowAll} />
                    </PortalPopup>
                )} */}

            </Spin>
        )
    }

    return null
}

export default ProfileInfo

const Groups = [{
    name: 'Alpharetta GA',
    status: 'Active',
    start: 'May 22, 2022 -',
    end: 'Present'
},
{
    name: 'Blount Business Connectors',
    status: 'Canceled',
    start: 'Jun 15, 2021 -',
    end: 'Jun 14, 2022'
},
{
    name: 'Jacksonville Veterans Group',
    status: 'Rejected',
    start: '-',
    end: ''
},
{
    name: 'GY Catalyst Group',
    status: 'Pending application',
    start: 'Pending',
    end: '2 days ago'
}]